import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      // Common elements
      "common.continue": "Continue",
      "common.processing": "Processing...",
      "common.back": "Back",
      "common.loading": "Loading...",
      "common.step": "Step",
      "common.total": "Total (incl. tax & fees)",
      "common.priceWithCurrency": "€{{price}}",
      "common.verify": "Verify",
      "common.verifyPhone": "Verify Phone",
      "common.change": "Change",
      "common.close": "Close",
      "common.includesAll": "(includes all taxes and fees)",
      "common.cancel": "Cancel",
      "common.confirm": "Confirm",
      "common.hostedBy": "Hosted by",
      "common.aboutEvent": "About event",
      "common.perItem": "Per item",
      "common.poweredBy": "Powered by",
      "common.showMore": "Show more",
      "common.showLess": "Show less",
      "common.includes": "Includes",

      // Dietary preference modal
      "dietary.stepLabel": "Dietary preferences",
      "dietary.description":
        "Your tickets include meals. Choose a dietary option for each ticket.",
      "dietary.ticketLabel": "Ticket {{num}}",

      // Buttons
      "button.continueWithout": "Continue without Add-ons",
      "button.openTikkie": "Open Tikkie Window",
      "button.verifyPhone": "Verify Phone",
      "button.payAndConfirm": "Pay & Confirm booking",

      // Tickets & Add-ons
      "tickets.title": "Select Tickets",
      "tickets.soldOut": "Sold Out",
      "tickets.taxesIncluded": "incl. all taxes and fees",
      "tickets.perTicket": "Per ticket",
      "tickets.selectAtLeastOne": "Select at least one ticket",
      'tickets.limit': 'Limited time offer',
      "tickets.orderDetails": "Order Details",
      "tickets.maxPerOrder": "You can buy maximum {{count}} tickets per order",
      "tickets.maxTicketsOfType":
        "You can buy maximum {{count}} {{type}} tickets",
      "tickets.maxAvailable": "You can buy maximum {{count}} tickets",
      "tickets.closingDate": "Closing {{date}}",

      // Add-ons section
      "addons.title": "Select Add-ons",
      "addons.message": " Get Online discount and skip unnecessary queues",
      "addons.selectAddons": "Select Add-ons",
      "addons.continueWithout": "Continue without Add-ons",
      "addons.pleaseSelectTicket": "Please select at least one ticket first",
      "addons.maxPerTicket": "You can only add {{count}} {{name}} per ticket",

      // User information
      "user.fillDetails": "Fill your details",
      "user.fullName": "Full name",
      "user.email": "Email",
      "user.phone": "Phone number",
      "user.emailTickets": "We will send your event tickets on this email ID.",
      "user.phoneVerification":
        " We may verify your entered phone number by sms.",

      // Payment methods
      "payment.selectMethod": "Select your Payment Method",
      "payment.atVenue": "Pay at Venue",
      "payment.card": "Card",
      "payment.tikkie": "Tikkie",
      "payment.ideal": "iDEAL",
      "payment.selectBank": "Select Bank",
      "payment.applePay": "Apple Pay",
      "payment.googlePay": "Google Pay",
      "payment.processing": "Processing fee:",
      "payment.free": "Free",
      "payment.R&P": "Review & Pay",

      // Tikkie specific
      "tikkie.newWindow":
        "Tikkie needs to open new window to complete the payment flow",
      "tikkie.completing":
        "Please complete payments via Tikkie on another window just opened and return back to this window.",
      "tikkie.notOpen": "Tikkie did not open?",
      "tikkie.clickHere": "Click here",
      "tikkie.confirmingPayment": "Confirming your payment...",
      "tikkie.addingBooking": "Adding your booking...",
      "tikkie.openWindow": "Open Tikkie window",

      // Phone verification
      "phone.verification": "Phone Verification",
      "phone.enterCode": "Enter the verification code sent to your phone",
      "phone.resend": "Resend Code",
      "phone.verifyPhone": "Verify Phone",
      "phone.verified": "Phone Verified",
      "phone.confirmation":
        "Your phone number {{phone}} has been verified successfully.",

      // OTP Modal
      "otp.title": "Phone Verification Required",
      "otp.message":
        "To complete your {{price}} booking, we need to verify your phone number.",
      "otp.freeMessage":
        "To complete your free booking, we need to verify your phone number.",

      // Error messages
      "error.fullNameRequired": "Full name is required",
      "error.emailRequired": "Email is required",
      "error.emailInvalid": "Email is invalid",
      "error.phoneRequired": "Phone number is required",
      "error.phoneInvalid": "Phone number is invalid",
      "error.selectPaymentMethod":
        "You have select at least one payment method to proceed.",
      "error.selectBank":
        "You have selected iDEAL as payment method. Please select a bank as well.",
      "error.eventClosedOrInvalid": "This event is not yet open for booking. Please use correct Booking link.",
      "error.eventClosed": "This event is not yet open for booking.",
      "error.eventExpired": "This event is no longer open for booking.",
      "error.noSchedules": "The Event has no schedules",
      "error.termsRequired": "Please agree to the terms of service",
      "error.paymentFailed":
        "An error occurred while generating payment link. Please try again later.",
      "error.selectticket": "Select at least once ticket.",
      "error.salesChannelClosed": "This sales channel is no more active for this event.",
      "error.timeOutTitle": "Time-out",
      "error.timeOutDetail": "Your cart has been emptied because your order was not completed in time.This event is not yet open for booking.",
      "error.reservationExpiredInTime": "Reserved for {{minutes}} minutes and {{seconds}} seconds.",
      "error.reservationExpired": "Reservation expired.",
      "error.intentIsMissing": "Payment intent is missing. Please try again.",
      "error.payment_succeeded": "Payment succeeded",
      "error.payment_failed": "Payment failed",
      "error.payment_canceled": "Payment canceled",
      "error.pleaseTryAgain": "Please try again",
      "error.paymentwasNotSuccessful": "Your payment was not successful. Please try again.",

      // Terms & conditions
      "terms.agree": "By clicking pay and confirm",
      "terms.agreeto": "I agree to",
      "terms.termsAndConditions": "Terms & Conditions",
      "terms.of": "of tikitly",

      // Order Confirmation
      "order.confirmation": "Order Confirmation",
      "order.loading": "Getting your booking confirmation...",
      "order.confirmed": "Your Order is Confirmed!!",
      "order.detailsSent": "Your Booking Details are sent to",
      "order.freeEvent": "Free Event",
      "order.paymentsDue": "Payments Due",
      "order.paymentConfirmed": "Payment Confirmed",
      "order.tickets": "Tickets",
      "order.addons": "Add-ons",
      "order.processingFee": "Processing fee",
      "order.totalVat": "Total (inc. VAT)",
      "order.hostPaymentNotice": "Host may send you a payment request before start of the event",
      "order.downloadTicket": "Download Ticket",
      "order.bookAgain": "Book Again",
      "order.gettingYourBooking": "Getting your booked tickets...",
      "order.downloadYourTickets": "Download your Tickets",
      "order.downloadYourAddOns": "Download your Add-ons",
      "order.downloadBtn": "Download",
      "order.wrongBooking": "Your booking cannot be found. If you already complete the booking, please send an email to support@bookzy.nl to request support.",
    },
  },
  nl: {
    translation: {
      // Common elements
      "common.continue": "Doorgaan",
      "common.processing": "Verwerken...",
      "common.back": "Terug",
      "common.loading": "Laden...",
      "common.step": "Stap",
      "common.total": "Totaal (incl. btw & kosten)",
      "common.priceWithCurrency": "€{{price}}",
      "common.verify": "Verifiëren",
      "common.change": "Wijzigen",
      "common.close": "Sluiten",
      "common.includesAll": "(inclusief alle belastingen en kosten)",
      "common.cancel": "Annuleren",
      "common.confirm": "Bevestigen",
      "common.hostedBy": "Gehost door",
      "common.aboutEvent": "Over evenement",
      "common.perItem": "Per stuk",
      "common.poweredBy": "Aangedreven door",
      "common.showMore": "Meer weergeven",
      "common.showLess": "Minder weergeven",
      "common.includes": "Inclusief",

      // Dietary preference modal
      "dietary.stepLabel": "Dieetwensen",
      "dietary.description":
        "Bij je tickets zijn maaltijden inbegrepen. Kies een dieetoptie voor elk ticket.",
      "dietary.ticketLabel": "Ticket {{num}}",

      // Buttons
      "button.continueWithout": "Doorgaan zonder add-ons",
      "button.openTikkie": "Open Tikkie Venster",
      "button.verifyPhone": "Verifieer Telefoon",
      "button.payAndConfirm": "Betalen & Boeking bevestigen",

      // Tickets & Add-ons
      "tickets.title": "Kies uw tickets",
      "tickets.soldOut": "Uitverkocht",
      "tickets.taxesIncluded": "incl. alle belastingen en kosten",
      "tickets.perTicket": "per kaartje",
      "tickets.selectAtLeastOne": "Kies uw tenminste één ticket",
      "tickets.limit": "Beperkte tijd aanbieding",
      "tickets.maxPerOrder":
        "Je kunt maximaal {{count}} tickets per bestelling kopen",
      "tickets.maxTicketsOfType":
        "Je kunt maximaal {{count}} {{type}} tickets kopen",
      "tickets.maxAvailable": "Je kunt maximaal {{count}} tickets kopen",
      "tickets.orderDetails": "Bestelgegevens",
      "tickets.closingDate": "Sluitingsdatum {{date}}",

      // Add-ons section
      "addons.title": "Kies uw Add-ons",
      "addons.message": "Krijg online korting en sla onnodige rijen over",
      "addons.selectAddons": "Kies uw Add-ons",
      "addons.continueWithout": "Doorgaan zonder Add-ons",
      "addons.pleaseSelectTicket": "Kies uw eerst tenminste één ticket",
      "addons.maxPerTicket":
        "Je kunt slechts {{count}} {{name}} per ticket toevoegen",

      // User information
      "user.fillDetails": "Vul je gegevens in",
      "user.fullName": "Volledige naam",
      "user.email": "E-mail",
      "user.phone": "Telefoonnummer",
      "user.emailTickets":
        "We sturen je evenementtickets naar dit e-mailadres.",
      "user.phoneVerification": " We kunnen je ingevoerde telefoonnummer verifiëren via sms.",


      // Payment methods
      "payment.selectMethod": "Kies uw Betaalmethode",
      "payment.atVenue": "Betalen op locatie",
      "payment.card": "Creditcard",
      "payment.tikkie": "Tikkie",
      "payment.ideal": "iDEAL",
      "payment.selectBank": "Kies uw Bank",
      "payment.applePay": "Apple Pay",
      "payment.googlePay": "Google Pay",
      "payment.processing": "Verwerkingskosten:",
      "payment.free": "Gratis",
      "payment.R&P": "Beoordelen & Betalen",

      // Tikkie specific
      "tikkie.newWindow":
        "Tikkie moet een nieuw venster openen om de betaling te voltooien",
      "tikkie.completing":
        "Voltooi de betaling via Tikkie in het andere geopende venster en keer terug naar dit venster.",
      "tikkie.notOpen": "Tikkie niet geopend?",
      "tikkie.clickHere": "Klik hier",
      "tikkie.confirmingPayment": "Je betaling wordt bevestigd...",
      "tikkie.addingBooking": "Je boeking wordt toegevoegd...",
      "tikkie.openWindow": "Open Tikkie venster",

      // Phone verification
      "phone.verification": "Telefoonnummer Verificatie",
      "phone.enterCode":
        "Voer de verificatiecode in die naar je telefoon is gestuurd",
      "phone.resend": "Code opnieuw versturen",
      "phone.verifyPhone": "Verifieer Telefoon",
      "phone.verified": "Telefoon Geverifieerd",
      "phone.confirmation":
        "Je telefoonnummer {{phone}} is succesvol geverifieerd.",

      // OTP Modal
      "otp.title": "Telefoonnummer verificatie vereist",
      "otp.message":
        "Om je {{price}} boeking te voltooien, moeten we je telefoonnummer verifiëren.",
      "otp.freeMessage":
        "Om je gratis boeking te voltooien, moeten we je telefoonnummer verifiëren.",

      // Error messages
      "error.fullNameRequired": "Volledige naam is verplicht",
      "error.emailRequired": "E-mail is verplicht",
      "error.emailInvalid": "E-mail is ongeldig",
      "error.phoneRequired": "Telefoonnummer is verplicht",
      "error.phoneInvalid": "Telefoonnummer is ongeldig",
      "error.selectPaymentMethod":
        "Je moet minstens één betaalmethode selecteren om door te gaan.",
      "error.selectBank":
        "Je hebt iDEAL als betaalmethode geselecteerd. Kies uw ook een bank.",
      "error.eventClosedOrInvalid": "Dit evenement is nog niet open voor boekingen. Gebruik de juiste boekingslink.",
      "error.eventClosed": "Dit evenement is nog niet open voor boekingen.",
      "error.eventExpired": "Dit evenement is niet meer open voor boekingen.",
      "error.noSchedules": "Het evenement heeft geen schema's",
      "error.termsRequired": "Ga akkoord met de servicevoorwaarden",
      "error.paymentFailed":
        "Er is een fout opgetreden bij het genereren van de betaallink. Probeer het later opnieuw.",
      "error.selectticket": "Selecteer minimaal één ticket.",
      "error.salesChannelClosed": "Dit verkoopkanaal is niet meer actief voor dit evenement.",
      "error.timeOutTitle": "Time-out",
      "error.timeOutDetail": "Uw winkelwagen is leeggemaakt omdat uw bestelling niet op tijd is voltooid. U kunt dit evenement nog niet boeken.",
      "error.reservationExpiredInTime": "Gereserveerd voor {{minutes}} minuten en {{seconds}} seconden.",
      "error.reservationExpired": "Reservering verlopen.",
      "error.intentIsMissing": "Betaalintentie ontbreekt. Probeer het opnieuw.",
      "error.payment_succeeded": "Betaling gelukt",
      "error.payment_failed": "Betaling mislukt",
      "error.payment_canceled": "Betaling geannuleerd",
      "error.pleaseTryAgain": "Probeer het opnieuw",
      "error.paymentwasNotSuccessful": "Uw betaling is mislukt. Probeer het opnieuw.",

      // Terms & conditions
      "terms.agree":
        "Door op betalen en bevestigen te klikken ga ik akkoord met de",
      "terms.agreeto": "Ik ga akkoord met",
      "terms.termsAndConditions": "Algemene Voorwaarden",
      "terms.of": "van tikitly",

      // Order Confirmation
      "order.confirmation": "Orderbevestiging",
      "order.loading": "Je boekingsbevestiging wordt opgehaald...",
      "order.confirmed": "Je bestelling is bevestigd!!",
      "order.detailsSent": "Je boekingsgegevens zijn verzonden naar",
      "order.freeEvent": "Gratis evenement",
      "order.paymentsDue": "Betalingen verschuldigd",
      "order.paymentConfirmed": "Betaling bevestigd",
      "order.tickets": "Tickets",
      "order.addons": "Add-ons",
      "order.processingFee": "Verwerkingskosten",
      "order.totalVat": "Totaal (incl. BTW)",
      "order.hostPaymentNotice": "De organisator kan je een betaalverzoek sturen voor aanvang van het evenement",
      "order.downloadTicket": "Ticket downloaden",
      "order.bookAgain": "Opnieuw boeken",
      "order.gettingYourBooking": "Uw tickets boeken...",
      "order.downloadYourTickets": "Download uw tickets",
      "order.downloadYourAddOns": "Download uw add-ons",
      "order.downloadBtn": "Download",
      "order.wrongBooking": "Je boeking kan niet gevonden worden. Als je de boeking al hebt voltooid, stuur dan een e-mail naar support@bookzy.nl om ondersteuning aan te vragen.",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['nl', 'en'],
    resources,
    fallbackLng: "nl",
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
    },
    debug: process.env.NODE_ENV === "development",
  });

export default i18n;